import axiosStatic from 'axios';

import {config} from '../config';

export const axios = axiosStatic.create({
    baseURL: config.pathianDataApiUrl
});

axios.interceptors.request.use(async requestConfig => {
    if (requestConfig.url?.startsWith('/') && requestConfig.url !== '/user_token') {
        try {
            requestConfig.headers['Ocp-Apim-Subscription-Key'] = localStorage.pathianDataApiKey;
        } catch (e) {
            // if the error is ClientAuthError, we do NOT want to throw
            // instead, perform the request without an Authorization header
            if ((e).name !== "ClientAuthError") {
                throw e;
            }
        }
    }
    return requestConfig;
});

axios.interceptors.response.use(async response => {
    return response;
});

export class PathianDataApiService {
    async getEnergySummary(equipmentIds, startDate, endDate, benchmarkStartDate, benchmarkEndDate, electricRate, thermalRate) {
        try {
            const {data} = await axios.get('/getEnergySummary', {
                params : {
                    equipmentIds: equipmentIds.join(','),
                    startDate,
                    endDate,
                    benchmarkStartDate,
                    benchmarkEndDate,
                    templateId: 53,
                    electricRate,
                    electricUnit: '$/kwh',
                    thermalRate,
                    thermalUnit: '$/therm'
            }});
            return data;
        } catch (e) {
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.statusText};
            } else {
                return null;
            }
        }
    }
    async getData(equipmentPointIds, startDate, endDate, benchmarkStartDate, benchmarkEndDate, xAxis, difference) {
        try {
            const {data} = await axios.get('/getData', {
                params : {
                    pointId: equipmentPointIds.join(','),
                    startDate,
                    endDate,
                    benchmarkStartDate,
                    benchmarkEndDate,
                    xAxis,
                    difference
                }});
            return data;
        } catch (e) {
            console.log('error', e)
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.statusText};
            } else {
                return null;
            }
        }
    }

    async getCalculatedData(equipmentId, functionId, startDate, endDate, benchmarkStartDate, benchmarkEndDate, xAxis) {
        try {
            const {data} = await axios.get('/getCalculatedData', {
                params : {
                    equipmentId,
                    functionId,
                    startDate,
                    endDate,
                    benchmarkStartDate,
                    benchmarkEndDate,
                    xAxis
                }});
            return data;
        } catch (e) {
            console.log('error', e)
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.statusText};
            } else {
                return null;
            }
        }
    }

    async getEnergyReportData(formData) {
        try {
            const {data} = await axios.post('/getEnergyReportData', {
                ...formData
            });
            return data;
        } catch (e) {
            console.log('error', e)
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.statusText};
            } else {
                return null;
            }
        }
    }

    async createEquipment(formData) {
        try {
            const {data} = await axios.post('/CreateEquipment', {
                ...formData
            });
            return data;
        } catch (e) {
            console.log('error', e)
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.data?.message || e.response.statusText};
            } else {
                return null;
            }
        }
    }

    async getGroupReportData(formData) {
        try {
            const {data} = await axios.post('/GetGroupReportData', {
                ...formData
            });
            return data;
        } catch (e) {
            console.log('error', e)
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.statusText};
            } else {
                return null;
            }
        }
    }
}

export const pathianDataApiService = new PathianDataApiService();
